<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/e2iqPz/tc-custom/9781631952203.jpg?1701061265442" alt="This image is the cover for the book Little Lark Still Sings"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Little Lark Still Sings
      </h1>
      <p class="bookDescription body article font2">
        <b>In this memoir of life abroad, a married couple discovers the charms and challenges of Italy when they buy their Tuscan dream home.</b><br/><br/>Happily married for two decades, Victoria and Larry decide to move to their favorite hilltown in Tuscany. But what begins as a romantic adventure soon becomes a drama of change and perseverance. Alongside Italy’s wonders—its beauty, art, architecture, food, and history—come the challenges of daily life in a foreign culture, surviving the chaos of construction, navigating narrow roads, longing for friends, stumbling with language, and so much more. As these struggles undermine Victoria’s confidence which, in turn, wears on Larry’s patience.<br/><br/>Though they share a dream, they discover their personal goals are different. His are to study and write, hers are to create the perfect Italian home and make friends. He needs quiet time; she needs his help. From the joys and near disasters of renovating an ancient stone farmhouse to celebrating their first Italian dinner party, Victoria learns about Italy, herself, and their marriage. In <i>The Little Lark Still Sings</i>, she shares their humorous and character-stretching experiences with uplifting insight and wisdom.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Victoria Smith
      </h2>
      
      <p class="authorDescription body article"><B>Victoria Smith</B> is a marketing executive who gave up her comfortable American life for the romantic adventure of moving to Tuscany with her husband. Typically undaunted — one of the first women in marketing at Procter & Gamble in the early 1970s, mega-agency advertising executive in the 1980s, single mom for over a decade — Victoria’s confidence was rocked by the hurdles of actually living in a foreign culture. Today, she and her husband are fully engaged in their hilltown community, zip up narrow steep roads, press their own olive oil, host friends and family, and are inspired every day by Italy’s <I>dolce vita</I>. Victoria continues her writing and work with local and global entities and returns to the USA to enjoy time with their kids and grandkids.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?21e1f66c